<template>
  <div
    class="the-utils-emails"
    v-loading="isEmailsLoading"
  >
    <h3>Список подписчиков e-mail рассылки</h3>
    <div class="the-utils-emails__controls">
      <el-tooltip content="Обновить данные" placement="top">
        <el-button @click="handleRefresh" type="primary" icon="el-icon-refresh-left" circle size="mini" :loading="isEmailsLoading"></el-button>
      </el-tooltip>

      <!-- <el-tooltip content="Удалить дубликаты" placement="top">
        <el-button @click="handleDeleteDuplicates" type="warning" icon="el-icon-document-copy" circle size="mini"></el-button>
      </el-tooltip> -->

      <el-tooltip content="Скачать файл" placement="top">
        <el-button @click="handleDownload" type="success" icon="el-icon-download" circle size="mini"></el-button>
      </el-tooltip>
    </div>

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="emailsCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

    <k-emails-table class="the-utils-emails__table" :emails="emails" @delete="handleDeleteEmail"/>

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="emailsCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

  </div>
</template>

<script>
/**
 * Component: the-utils-emails - Компонент отбражения и управления списком рассылки
 *
 * @version 1.0.0
 */


import { mapGetters, mapActions } from 'vuex';

import downloadFile from '@/util/downloadFile';

// Components
import KEmailsTable from '@/components/KEmailsTable.vue';


const NUMBER_OF_EMAILS_PER_PAGE = 10;


export default {
  name: 'the-utils-emails',

  data() {
    return {
      currentPage: 0,
    };
  },

  computed: {
    // Общее количество страниц с e-mail
    numberOfPages() {
      return Math.ceil(this.emailsCount / NUMBER_OF_EMAILS_PER_PAGE);
    },

    ...mapGetters({
      emails: 'emails/emails',
      emailsCount: 'emails/emailsCount',
      isEmailsLoading: 'emails/isEmailsLoading',
    }),
  },

  async created() {
    await this.update();
  },

  methods: {
    async update() {
      await this.getEmails({
        limit: NUMBER_OF_EMAILS_PER_PAGE,
        offset: this.currentPage,
      });
    },

    // Обновить данные
    async handleRefresh() {
      await this.update();
    },

    // Удалить дубликаты
    handleDeleteDuplicates() {

    },

    // Скачать файл со список рассылки
    async handleDownload() {
      let emails = await this.getAllEmails();
      emails = emails.map(e => ({ time: '', ...e }));
      let csvContent = '' + emails.map(e => Object.values(e).join(',')).join('\n');
      downloadFile(csvContent, 'email.csv', 'csv');
    },

    // Удаление e-mail
    async handleDeleteEmail(id) {
      await this.deleteEmails([id]);
      await this.update();
    },

    async setCurrentPage(numberOfPage) {
      this.currentPage = numberOfPage - 1;
      await this.update();
    },

    ...mapActions({
      deleteEmails: 'emails/deleteEmails',
      getAllEmails: 'emails/getAllEmails',
      getEmails: 'emails/getEmails',
    }),
  },

  components: {
    KEmailsTable,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-utils-emails {
  $this: &;

  &__table {
    margin-bottom: $vp;
  }

  &__controls {
    margin-bottom: 24px;
  }
}
</style>
